import {
	getAllGameApi,
	getPackageApi,
	getRankApi,
	getGiftApi,
	getListRoomOfGameApi,
	createRoomOfGameApi,
	checkStartGameApi,
	getRoomDetailOfGameApi,
	getListFriendInvitePlayGameApi,
	getLevelRoomOfGameApi,
	createRoomByPlayNowApi,
	joinRoomNowApi,
	getPageInfoApi,
	CancelPackageApi,
	getRankPointApi,
	getRankEventWater,
	getCheckEventWater,
	getDropEventWater,
	getRankEventBoatRacing,
	getCheckEventBoatRacing,
	getStepEventBoatRacing,
	startSpinBoatRacingApi,
	startPairingEventBunpimay,
	getRankEventBunpimay,
	getItemsEventBunpimay,
	getCheckEventBunpimay,
	checkSubApi,
	getCheckEventBoatRacing102025,
	getBoatRacing102025Boat,
	getBoatRacing102025Rank,
	getLuckyGameAward,
	luckyStartGameSpin,
	luckyGetHistory,
	LuckyGetDailyMission,
	LuckyGetReceiveDailyMissionReward,
} from 'api/game'
import { getFriendApi, getUserInfoApi } from 'api/user'
import { useMutation, useQueryClient } from 'react-query'

export const queryKeyAllGame = 'allGame'
export const queryKeyPageInfo = 'pageInfo'
export const queryKeyPackage = 'package'
export const queryKeyRank = 'rank'
export const queryKeyReward = 'reward'
export const queryKeyFriend = 'friend'
export const queryKeyListRoom = 'listRoom'
export const queryKeyLevelRoom = 'levelRoom'
export const queryKeyCreateRoom = 'createRoom'
export const queryKeyCreateRoomByPlayNow = 'createRoomByPlayNow'
export const queryKeyJoinRoomNow = 'joinRoomNow'
export const queryKeyCheckStartGame = 'checkStartGame'
export const queryKeyDetailRoom = 'detailRoom'
export const queryKeyFriendPlayGame = 'friendPlayGame'
export const queryKeyCancelPackage = 'cancelPackage'
export const queryKeyUserInfo = 'userInfo'
export const queryKeyRankWater = 'rankWater'
export const queryKeyCheckWater = 'checkWater'
export const queryKeyDropWater = 'dropWater'
export const queryKeyCheckBoatRacing = 'checkBoatRacing'
export const queryKeyRankBoatRacing = 'rankBoatRacing'
export const queryKeyGetStepBoatRacing = 'getStepBoatRacing'
export const queryKeyStartSpinBoatRacing = 'startSpinBoatRacing'

export const queryKeyCheckBunpimay = 'checkBunpimay'
export const queryKeyGetItemBunpimay = 'getItemBunpimay'
export const queryKeyPairingBunpimay = 'pairingBunpimay'
export const queryKeyRankBunpimay = 'rankBunpimay'

export const queryKeycheckSub = 'checkSub'
export const queryKeycheckEventBoatRacing102025 = 'checkEventBoatRacing102025'
export const queryKeycheckEventBoatRacingBoat = 'checkEventBoatRacing102025Boat'
export const queryKeycheckEventBoatRacingRank = 'checkEventBoatRacing102025Rank'
export const queryLuckyGameAward = 'getLuckyGameAward'
export const queryluckyStartGameSpin = 'luckyStartGameSpin'
export const queryLuckyGetHistory = 'LuckyGetHistory'
export const queryLuckyGetDailyMission = 'LuckyGetDailyMission'
export const queryLuckyGetReceiveDailyMissionReward =
	'LuckyGetReceiveDailyMissionReward'

export const getAllGameQuery = () => ({
	queryKey: [queryKeyAllGame],
	queryFn: getAllGameApi,
	refetchOnWindowFocus: false,
})
export const getPageInfoQuery = () => ({
	queryKey: [queryKeyPageInfo],
	queryFn: getPageInfoApi,
	refetchOnWindowFocus: false,
})

export const getPackageQuery = () => ({
	queryKey: [queryKeyPackage],
	queryFn: getPackageApi,
})

export const getRankPointQuery = (offset = 0, limit = 10) => ({
	queryKey: [queryKeyRank, { offset, limit }],
	queryFn: getRankPointApi,
})
export const getRankQuery = (
	time = 'month',
	offset = 0,
	limit = 10,
	userId,
) => ({
	queryKey: [queryKeyRank, { time, offset, limit, userId }],
	queryFn: getRankApi,
})

export const getGiftQuery = () => ({
	queryKey: [queryKeyReward],
	queryFn: getGiftApi,
})

export const getFriendQuery = () => ({
	queryKey: [queryKeyFriend],
	queryFn: getFriendApi,
})

export const getListRoomOfGameQuery = (
	game_id = 0,
	offset = 0,
	limit = 10,
	q = '',
	level = 1,
) => ({
	queryKey: [queryKeyListRoom, { game_id, offset, limit, q, level }],
	queryFn: getListRoomOfGameApi,
})
export const getLevelRoomOfGameQuery = () => ({
	queryKey: [queryKeyLevelRoom],
	queryFn: getLevelRoomOfGameApi,
	refetchOnWindowFocus: false,
})

export const getListFriendInvitePlayGameQuery = (offset = 0, limit = 10) => ({
	queryKey: [queryKeyFriendPlayGame, { offset, limit }],
	queryFn: getListFriendInvitePlayGameApi,
})

export const getRoomDetailOfGameQuery = room_id => ({
	queryKey: [queryKeyDetailRoom, { room_id }],
	queryFn: getRoomDetailOfGameApi,
	cacheTime: 0,
})

export const useCreateRoomOfGame = (callbackSuccess = () => { }) => {
	const queryClient = useQueryClient()
	return useMutation(createRoomOfGameApi, {
		onSuccess: data => {
			callbackSuccess(data)
		},
		onError: error => {
			console.log('error create room:', error)
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyCreateRoom)
		},
	})
}

export const useCheckStartGame = (callbackSuccess = () => { }) => {
	const queryClient = useQueryClient()
	return useMutation(checkStartGameApi, {
		onSuccess: data => {
			callbackSuccess(data)
		},
		onError: error => {
			console.log('error create room:', error)
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyCheckStartGame)
		},
	})
}
export const getUserInfoQuery = () => ({
	queryKey: [queryKeyUserInfo],
	queryFn: getUserInfoApi,
})
export const useCreateRoomByPlayNowOfGame = (
	callbackSuccess = () => { },
	callbackError = () => { },
) => {
	const queryClient = useQueryClient()
	return useMutation(createRoomByPlayNowApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyCreateRoomByPlayNow, data)
			if (data && parseInt(data.responseCode) !== 200) {
				callbackError(data)
			} else {
				callbackSuccess(data)
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyCreateRoomByPlayNow)
		},
	})
}
export const useJoinRoomNowOfGame = (
	callbackSuccess = () => { },
	callbackError = () => { },
) => {
	const queryClient = useQueryClient()
	return useMutation(joinRoomNowApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyJoinRoomNow, data)
			if (data && parseInt(data.responseCode) !== 200) {
				callbackError(data)
			} else {
				callbackSuccess(data)
			}
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyJoinRoomNow)
		},
	})
}
export const useCancelPackage = (
	callbackSuccess = () => { },
	callbackError = () => { },
) => {
	const queryClient = useQueryClient()

	return useMutation(CancelPackageApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyCancelPackage, data.data)
			if (
				(data && parseInt(data.responseCode) === 200) ||
				(data && data.message === 'Success')
			) {
				callbackSuccess(data.data)
			} else {
				callbackError(data)
			}
		},
		onError: error => {
			callbackError(error)
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyCancelPackage)
		},
	})
}
export const getRankEventWaterQuery = (
	page = 1,
	my_rank = 0,
	pagesize = 10,
) => ({
	queryKey: [queryKeyRankWater, { page, pagesize, my_rank }],
	queryFn: getRankEventWater,
})
export const getCheckEventWaterQuery = () => ({
	queryKey: [queryKeyCheckWater],
	queryFn: getCheckEventWater,
	enabled: false,
	retry: false,
})
export const getDropEventWaterQuery = () => ({
	queryKey: [queryKeyDropWater],
	queryFn: getDropEventWater,
})
export const getRankEventBoatRacingQuery = (
	page = 1,
	my_rank = 0,
	limit = 10,
) => ({
	queryKey: [queryKeyRankBoatRacing, { page, limit, my_rank }],
	queryFn: getRankEventBoatRacing,
})

export const getCheckEventBoatRacingQuery = () => ({
	queryKey: [queryKeyCheckBoatRacing],
	queryFn: getCheckEventBoatRacing,
	enabled: false,
	retry: false,
})

export const getStepEventBoatRacingQuery = () => ({
	queryKey: [queryKeyGetStepBoatRacing],
	queryFn: getStepEventBoatRacing,
})
export const useStartSpinEventBoatRacing = (
	callbackSuccess = () => { },
	callbackError = () => { },
) => {
	const queryClient = useQueryClient()

	return useMutation(startSpinBoatRacingApi, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyStartSpinBoatRacing, data.data)
			if (
				(data && parseInt(data.responseCode) === 200) ||
				(data && data.message === 'Success')
			) {
				callbackSuccess(data.data)
			} else {
				callbackError(data)
			}
		},
		onError: error => {
			callbackError(error)
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyStartSpinBoatRacing)
		},
	})
}
export const getCheckEventBunpimayQuery = () => ({
	queryKey: [queryKeyCheckBunpimay],
	queryFn: getCheckEventBunpimay,
	enabled: false,
	retry: false,
})

export const getItemsEventBunpimayQuery = () => ({
	queryKey: [queryKeyGetItemBunpimay],
	queryFn: getItemsEventBunpimay,
})
export const getRankEventBunpimayQuery = (
	page = 1,
	my_rank = 0,
	limit = 10,
	isFetchingRank,
) => ({
	queryKey: [queryKeyRankBunpimay, { page, limit, my_rank }],
	queryFn: getRankEventBunpimay,
	enabled: isFetchingRank,
})

export const useStartPairingEventBunpimay = (
	callbackSuccess = () => { },
	callbackError = () => { },
) => {
	const queryClient = useQueryClient()
	return useMutation(startPairingEventBunpimay, {
		onSuccess: data => {
			queryClient.setQueryData(queryKeyPairingBunpimay, data.data)
			if (
				(data && parseInt(data.responseCode) === 200) ||
				(data && data.message === 'Success')
			) {
				callbackSuccess(data.data)
			} else {
				callbackError(data)
			}
		},
		onError: error => {
			callbackError(error)
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeyStartSpinBoatRacing)
		},
	})
}

// --------------

export const useCheckSub = (callbackSuccess = () => { }) => {
	const queryClient = useQueryClient()
	return useMutation(params => checkSubApi(params), {
		onSuccess: data => {
			callbackSuccess(data)
		},
		onError: error => {
			console.log('error check sub:', error)
		},
		onSettled: async () => {
			queryClient.invalidateQueries(queryKeycheckSub)
		},
	})
}
export const getCheckEventBoatRacing102025Query = () => ({
	queryKey: [queryKeycheckEventBoatRacing102025],
	queryFn: getCheckEventBoatRacing102025,
})

export const getEventBoatRacing102025Boat = () => ({
	queryKey: [queryKeycheckEventBoatRacingBoat],
	queryFn: getBoatRacing102025Boat,
})
export const getEventBoatRacing102025Rank = ({ my_rank, limit }) => ({
	queryKey: [queryKeycheckEventBoatRacingRank, { my_rank, limit }],
	queryFn: () => getBoatRacing102025Rank({ my_rank, limit }),
	enabled: false,
	retry: false,
})

export const ListLuckyGameAward = () => ({
	queryKey: [queryLuckyGameAward],
	queryFn: () => getLuckyGameAward(),
	// enabled: false,
	// retry: false,
})

export const useLuckyStartGameSpin = callbackSuccess => {
	const queryClient = useQueryClient()

	return useMutation(luckyStartGameSpin, {
		onSuccess: data => {
			callbackSuccess?.(data)
		},
		onSettled: () => {
			queryClient.invalidateQueries(queryluckyStartGameSpin)
		},
	})
}

export const getLuckyGetDailyMission = () => ({
	queryKey: [queryLuckyGetDailyMission],
	queryFn: () => LuckyGetDailyMission(),
})

export const useReceiveDailyMissionReward = callbackSuccess => {
	const queryClient = useQueryClient()

	return useMutation(LuckyGetReceiveDailyMissionReward, {
		onSuccess: data => {
			callbackSuccess?.(data)
			queryClient.invalidateQueries([queryLuckyGetDailyMission])
		},
	})
}
